import initApp from '@springboardjs/platforms-cf-workers/entrypoints/cf_worker_browser_entrypoint.tsx';
import '../../../../modules/index.ts';
export * from '@springboardjs/platforms-cf-workers/entrypoints/cf_worker_browser_entrypoint.tsx';
export default initApp;
